import * as types from './_actionTypes';

const initialState = {
  enrolledCourse: null,
  progress: {
    videosWatched: 0,
    totalVideos: 0,
    quizzesCompleted: 0,
    totalQuizzes: 0,
    assessmentsCompleted: 0,
    totalAssessments: 0,
    examStatus: 'not_started'
  },
  recentActivities: [],
  notifications: [],
  loading: false,
  error: null
};

const studentDashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_STUDENT_DASHBOARD_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    
    case types.FETCH_STUDENT_DASHBOARD_SUCCESS:
      return {
        ...state,
        loading: false,
        ...action.payload,
        error: null
      };
    
    case types.FETCH_STUDENT_DASHBOARD_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    
    case types.UPDATE_STUDENT_PROGRESS:
      return {
        ...state,
        progress: {
          ...state.progress,
          ...action.payload
        }
      };
    
    default:
      return state;
  }
};

export default studentDashboardReducer;